<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8333 15.082C10.8333 15.303 10.7455 15.515 10.5893 15.6713C10.433 15.8276 10.221 15.9154 10 15.9154C9.77899 15.9154 9.56703 15.8276 9.41075 15.6713C9.25447 15.515 9.16667 15.303 9.16667 15.082C9.16667 14.861 9.25447 14.6491 9.41075 14.4928C9.56703 14.3365 9.77899 14.2487 10 14.2487C10.221 14.2487 10.433 14.3365 10.5893 14.4928C10.7455 14.6491 10.8333 14.861 10.8333 15.082ZM10.625 8.20703C10.625 8.04127 10.5592 7.8823 10.4419 7.76509C10.3247 7.64788 10.1658 7.58203 10 7.58203C9.83424 7.58203 9.67527 7.64788 9.55806 7.76509C9.44085 7.8823 9.37501 8.04127 9.37501 8.20703V11.957C9.37501 12.1228 9.44085 12.2818 9.55806 12.399C9.67527 12.5162 9.83424 12.582 10 12.582C10.1658 12.582 10.3247 12.5162 10.4419 12.399C10.5592 12.2818 10.625 12.1228 10.625 11.957V8.20703Z"
      fill="#DC3030"
    />
    <path
      d="M8.19667 3.20469C8.99917 1.81719 11.0008 1.81719 11.8033 3.20469L19.2758 16.1247C20.0783 17.5139 19.0758 19.2514 17.4717 19.2514H2.52834C0.923336 19.2514 -0.0783307 17.5139 0.724169 16.1247L8.19667 3.20469ZM10.7217 3.83052C10.6482 3.70427 10.5429 3.5995 10.4162 3.52669C10.2896 3.45387 10.1461 3.41555 10 3.41555C9.85392 3.41555 9.7104 3.45387 9.58377 3.52669C9.45713 3.5995 9.35182 3.70427 9.27834 3.83052L1.80667 16.7505C1.73386 16.8773 1.69561 17.021 1.69576 17.1672C1.6959 17.3134 1.73444 17.457 1.8075 17.5836C1.88057 17.7103 1.9856 17.8155 2.1121 17.8888C2.2386 17.9621 2.38213 18.0009 2.52834 18.0014H17.4717C17.6178 18.0008 17.7611 17.962 17.8875 17.8888C18.0139 17.8155 18.1189 17.7104 18.1919 17.5838C18.2649 17.4573 18.3035 17.3139 18.3038 17.1678C18.304 17.0217 18.2659 16.8781 18.1933 16.7514L10.7217 3.83052Z"
      fill="#DC3030"
    />
  </svg>
</template>

<script>
export default {
  name: "IconCaution",
};
</script>
